interface Properties {
  width?: number;
  height?: number;
  color?: string;
}

const FigmaTableIcon = ({ width = 16, height = 16, color = '#121826' }: Properties) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      {/* Header row */}
      <rect x='1' y='1' width='14' height='4.5' rx='1.5' fill={color} />
      {/* Row 2 col 1 */}
      <rect x='1' y='6.5' width='4' height='3.5' rx='1' fill={color} />
      {/* Row 2 col 2 */}
      <rect x='6' y='6.5' width='4' height='3.5' rx='1' fill={color} />
      {/* Row 2 col 3 */}
      <rect x='11' y='6.5' width='4' height='3.5' rx='1' fill={color} />
      {/* Row 3 col 1 */}
      <rect x='1' y='11' width='4' height='4' rx='1' fill={color} />
      {/* Row 3 col 2 */}
      <rect x='6' y='11' width='4' height='4' rx='1' fill={color} />
      {/* Row 3 col 3 */}
      <rect x='11' y='11' width='4' height='4' rx='1' fill={color} />
    </svg>
  );
};

export default FigmaTableIcon;
